import React from "react";
import Image from "next/image";
import Link from "next/link";
export type ProductWhyChooseUsProps = {
  title: string;
  highlight: string;
  benefits: {
    image: React.JSX.Element;
    title: string;
    description: string;
  }[];
};

export default function ProductWhyChooseUs({
  title,
  highlight,
  benefits,
}: ProductWhyChooseUsProps) {
  const [before, after] = title.split(highlight);

  return (
    <section className="flex flex-col gap-10">
      <div className="flex justify-center flex-col md:flex-row gap-4">
        <div className="flex gap-4 flex-col items-start md:items-center">
          <p className="flex items-center justify-center">
            <span className="bg-[#E7D7FD] rounded-full px-3 py-1 text-[#8937F4] inline-block font-semibold">
              <span className=" text-primary-900">WHY CHOOSE US?</span>{" "}
            </span>
          </p>
          <span className="md:text-[45px] text-2xl text-secondary-900 font-bold md:text-center">
            {before}{" "}
            <span className="bg-gradient-to-r from-[#4337cc] to-primary-900 bg-clip-text text-transparent">
              {highlight}
            </span>{" "}
            {after}
          </span>
        </div>
      </div>
      <div className="rounded-lg w-full bg-gradient-to-r from-[#4337cc] to-primary-900 flex py-8 px-8 sm:px-24 md:py-24 flex-col justify-between gap-10">
        {benefits.map((benefit) => (
          <div
            className="flex gap-8  items-start md:items-center"
            key={benefit.title}
          >
            <div className="md:min-w-[70px] min-w-[50px] h-full justify-center items-center flex">
              {benefit.image}
            </div>

            <div className="flex flex-col gap-4">
              <span className="text-xl text-white font-bold md:text-[27px]">
                {benefit.title}
              </span>
              <span className=" text-white text-base md:text-lg">
                {benefit.description}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
